module.exports = __webpack_public_path__ + "img/icon_scouting.2ef8dedb.png";